import React from "react";
import { Button, Glyphicon, Row, Col } from "react-bootstrap";
import _ from "lodash";

import CategoryActions from "../actions/CategoryActions";

import CategoryStore from "../stores/CategoryStore";

import Api from "../utils/Api";
import CategoryDeleteModal from "./CategoryDeleteModal";
import CategoryEditModal from "./CategoryEditModal";

const Enums = window.Enums;

export default class Categories extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = Categories.getStoreState();
		this.state.showCategoryDeleteModal = false;
		this.state.showCategoryEditModal = false;

		this._onChange = this._onChange.bind(this);
		this.editCategory = this.editCategory.bind(this);
		this.handleCategoryDeleteModalClose = this.handleCategoryDeleteModalClose.bind(this);
		this.handleCategoryEditModalClose = this.handleCategoryEditModalClose.bind(this);
	}

	static getStoreState()
	{
		return {
			categories: CategoryStore.getCategories()
		};
	}

	handleCategoryDeleteModalClose()
	{
		this.setState({
			deleteCategoryId: null,
			showCategoryDeleteModal: false
		});
	}

	handleCategoryEditModalClose()
	{
		this.setState({
			editCategoryId: null,
			showCategoryEditModal: false
		});
	}

	async handleCategoryDelete(categoryId)
	{
		const isInUse = await Api.categoryIsInUse(categoryId);
		if (isInUse)
		{
			this.setState({
				deleteCategoryId: categoryId,
				showCategoryDeleteModal: true
			});
		}
		else
		{
			await this.deleteCategory(categoryId);
		}
	}

	handleCategoryEdit(categoryId)
	{
		this.setState({
			editCategoryId: categoryId,
			showCategoryEditModal: true
		});
	}

	async deleteCategory(categoryId, replacementId)
	{
		await CategoryActions.deleteCategory(categoryId, replacementId);
	}

	async editCategory(category)
	{
		await CategoryActions.saveCategory(category);
	}

	_onChange()
	{
		this.setState(Categories.getStoreState());
	}

	componentDidMount()
	{
		CategoryStore.addChangeListener(this._onChange);
		CategoryActions.initialize();
	}

	componentWillUnmount()
	{
		CategoryStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const categories = this.state.categories;

		return (
			<Row>
				{this.state.showCategoryEditModal &&
					<CategoryEditModal
						onClose={this.handleCategoryEditModalClose}
						onSave={this.editCategory}
						category={_.cloneDeep(categories.find(c => c.id === this.state.editCategoryId))}
					/>
				}
				{this.state.showCategoryDeleteModal &&
					<CategoryDeleteModal
						onClose={this.handleCategoryDeleteModalClose}
						onDelete={this.deleteCategory.bind(this, this.state.deleteCategoryId)}
						categories={categories}
						categoryId={this.state.deleteCategoryId}
					/>
				}
				<Col xs={10} xsOffset={1}>
					<Row>
						<Col xs={3}>
							<strong>Category</strong>
						</Col>
						<Col xs={2}>
							<strong>Type</strong>
						</Col>
						<Col xs={7} />
					</Row>
					{categories.map(category => {
						let type = _.findKey(Enums.categoryType, typeValue => typeValue === category.type);
						type = type[0].toUpperCase() + type.substring(1);

						return (
							<Row key={category.id} className="category">
								<Col xs={3}>
									{category.name}
								</Col>
								<Col xs={2}>
									{type}
								</Col>
								<Col xs={7} className="category-buttons">
									<Button
										bsSize={"sm"}
										bsStyle={"default"}
										onClick={this.handleCategoryEdit.bind(this, category.id)}
									>
										<Glyphicon glyph="pencil"/>
									</Button>
									<Button
										bsSize={"sm"}
										bsStyle={"danger"}
										onClick={this.handleCategoryDelete.bind(this, category.id)}
									>
										<Glyphicon glyph={"trash"}/>
									</Button>
								</Col>
							</Row>
						);
					})}
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Categories.jsx